<confirmation-dialog>
  <div class="budget-settings-summary">
    <budget-settings-summary-bar
      [budgetTotal]="context.budgetTotal"
      [allocatedTotal]="context.allocatedTotal"
      [currency]="context.currency"
      [minimized]="true"
      [clickable]="false"
      [withConfetti]="false"
    ></budget-settings-summary-bar>
  </div>
  <p class="dialog-info" *ngIf="!context.isBudgetAnchorForecast">
    Your Grand Total of planned budget is greater than
    the total budget amount defined.  Do you want to
    <b>increase</b> the Grand Total by
    {{ context.currency?.symbol }} {{ -context.remainingBudget | number: '1.2-2' }}
    or <b>keep editing</b>?
  </p>

  <p class="dialog-info" [ngClass]="{'forecast-anchor': context.isBudgetAnchorForecast}" *ngIf="context.isBudgetAnchorForecast">
    Your forecast Grand Total is over the defined forecast amount.
    Increase it by
    {{ context.currency?.symbol }} {{ -context.remainingBudget | number: '1.2-2' }}
    or go back and edit your forecast values.
  </p>
</confirmation-dialog>
